// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1QuvM","disabled":"FileBtn_disabled__2cisq","warn":"FileBtn_warn__2WCEK","fade":"FileBtn_fade__3dkrd"};